import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
  return {
    root: {
      width: '100%',
      '& *, *:focus': {
        boxShadow: 'none !important',
      },
      '& .react-tabs__tab-list': {
        borderBottom: '1px solid #d8d8d8',
        display: 'flex',
        overflowX: 'auto',
        overflowY: 'hidden',
      },
      '& .react-tabs__tab': {
        border: 'none',
        padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
        color: '#546e7a',
        boxShadow: 'none',
        borderRadius: 0,
        outline: 'none',
        fontWeight: 500,
        fontSize: 14,
        transition: 'ease border .25s',
        borderBottom: '2px solid transparent',
        '&--selected': {
          color: theme.palette.primary.main,
          borderBottom: `2px solid ${theme.palette.primary.main}`,
        },
        '&:focus:after': {
          display: 'none',
          borderBottom: `2px solid ${theme.palette.primary.main}`,
        },
      },
    },
    panelsContainer: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    errors: {
      background: 'rgba(100,0,0,.15)',
      color: 'red',
      height: 22,
      paddingInlineStart: theme.spacing(1),
      paddingInlineEnd: theme.spacing(1),
      paddingTop: theme.spacing(0.3),
      display: 'inline-block',
      borderRadius: 100,
      marginInlineStart: theme.spacing(1.4),
    },
    tabContainer: { display: 'flex', flexWrap: 'wrap' },
    infoIcon: { marginLeft: '5px', fontSize: '20px' },
  };
});